module.exports = __webpack_public_path__ + "static/media/Castello-Branco-ADV-01.d057dbbc.jpg";